module.exports = __webpack_public_path__ + "static/media/Subtract05.28854442.svg";